import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Board from "./Board";
import useCourses from "./useCourses";
import { useSelector } from "react-redux";

const Courses = () => {
  const user = useSelector(store=>store.AppReducer.user);
  const {
    courses: { courses = [], isLoading },
    regenerate,
  } = useCourses();

  return (
    <Box>
      <Typography
        variant={"h5"}
        sx={{
          mb: 1,
          mt: 2,
        }}
      >
        <b>Cursos</b>
      </Typography>
      <Card
        raised
        sx={{
          gap: "1rem",
          padding: "1rem",
          backgroundColor: "#f5f5f5",
          boxShadow: "none",
          borderRadius: '0.6rem',
        }}
      >
        <CardContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1.05rem",
                  }}
                >
                  Nome do curso
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1.05rem",
                  }}
                >
                  Turmas (Início/Encerramento)
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1.05rem",
                  }}
                >
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {courses?.map((course, certificateKey) => (
                <Board
                  key={certificateKey}
                  user={user}
                  course={course}
                />
              ))}
            </TableBody>
          </Table>
          {courses.length==0 && isLoading==false ? <p style={{ textAlign:'center', marginBottom: 5, fontWeight: 'normal', fontSize: 16, marginTop: 10 }}>Nenhum curso encontrado</p>:<></>}
          {isLoading && (
            <Box>
              <CircularProgress />
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default Courses;
